/**
 * htmlDecode.js — SPD v5.88.1 production hotfix (2026-02-15).
 *
 * Brave Search and RAG document snippets come back with two flavours
 * of markup that MUST be decoded before display in a text-only
 * surface (citation modal, snippet cards, web-result circles):
 *
 *   • HTML entities like `&#x27;` (apostrophe), `&amp;`, `&quot;`,
 *     `&lt;`, `&gt;`, non-breaking spaces etc.
 *   • Element tags like `<strong>...</strong>` wrapping matched
 *     query terms (Brave's default markup mode).
 *
 * The pre-hotfix code dropped these strings straight into JSX, which
 * renders them as literal text. Operator flagged the regression via
 * a citation modal showing `<strong>Google&#x27;s...</strong>` verbatim.
 *
 * This helper:
 *   1. Uses a `textarea`'s HTML parser to decode entities safely
 *      (no eval, no innerHTML on mounted DOM, no XSS surface).
 *   2. Strips ALL HTML tags — snippets are plain-text summaries;
 *      bold-on-matched-terms isn't valuable enough to justify
 *      `dangerouslySetInnerHTML`.
 *   3. Collapses whitespace so the output reads naturally regardless
 *      of what markup came in.
 *
 * Safe against arbitrary Brave / RAG payloads.
 */
export function decodeExcerpt(raw) {
  if (!raw || typeof raw !== 'string') return '';
  // Step 1 · decode HTML entities via the browser's built-in parser.
  let decoded = raw;
  if (typeof document !== 'undefined') {
    const txt = document.createElement('textarea');
    txt.innerHTML = raw;
    decoded = txt.value;
  }
  // Step 2 · strip any leftover tags (e.g. Brave's <strong>).
  const stripped = decoded.replace(/<\/?[^>]+(>|$)/g, '');
  // Step 3 · collapse runs of whitespace to a single space.
  return stripped.replace(/\s+/g, ' ').trim();
}

export default decodeExcerpt;
